import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { CmsColDataCalc, CmsLayout, CmsPrintMargin, cmsMarginCss, cmsReceiptCol, cmsReceiptRow, cmsRecipt, cmsReciptStyle, LayoutContent, ReceiptData } from '../receipt-models';
import { HistApi } from 'src/app/services/api-service/hist/hist-api';
import { ClinicDataService } from 'src/app/services/data-service/clinic-data-service';
import { RegisterApi } from 'src/app/services/api-service/register/register-api';
import { ReportApi } from '../../reportApi';
import { CmsReport, CmsReportApi } from 'src/app/services/api-service/cms-report/cms-report-api';
import { CmsPrintReport } from 'src/app/services/api-service/clinic/clinic-api';
import { ChineseReceiptInfo, CmsReportAdditionalParamter, DrugBagInfo, ReceiptInfoDto } from 'src/app/services/api-service/hist/whole-large-hist';
import { PRN001Params } from 'src/app/services/api-service/parameters/PRN001Params';
import { HistEditOption } from 'src/app/services/api-service/hist/hist-edit-option';
import { RegistEditOpt } from 'src/app/services/api-service/register/register-api';
import { HcrService } from 'src/app/services/hcr-service.service';
import { HspidApi } from 'src/app/services/api-service/hspid/hspid-api';
import { Hspid } from 'src/app/services/api-service/hspid/hspid';
import { SessionService } from 'src/app/services/session.service';
import { ValueTextPair } from 'src/app/shared/models/value-text-pair';
import { OrderSpecialRuleEnum } from 'src/app/enums/OrderSpecialRuleEnum';
import { HistOrder } from 'src/app/hist/models/hist-order';
import { UserCache } from 'src/app/services/user-cache';
import { ChineseHrx, ChiReportApi } from 'src/app/services/api-service/hist/chi-report-api';

// 定義 RegDataCache class
export class RegDataCache {
  histAndIc: ReceiptInfoDto;
  p1: PRN001Params;
  opt1: HistEditOption;
  opt2: RegistEditOpt;
  useOutVisit: any;          // session string 或 boolean
  useOutVisitJail: any;      // session
  additionPrintSetting: any; // session

  constructor(init?: Partial<RegDataCache>) {
    Object.assign(this, init);
  }
}

@Component({
  selector: 'app-dynamic-recipt',
  templateUrl: './dynamic-recipt.component.html',
  styleUrls: ['./dynamic-recipt.component.css']
})
export class DynamicReciptComponent implements OnInit, AfterViewInit {

  private defaultFontSize = 14;
  private defaultFontFamily = '細明體';

  private data: ReceiptData;
  private report: CmsReport | CmsPrintReport;

  private isLayout: boolean = false;

  @Input() hrxPage: number = 0;
  @Input() hrxPerPage: number | null = null;
  get totalHrxCount(): number {
    return this.data?.getHrx()?.length ?? 0;
  }

  @Input()
  set cmsData(v: cmsRecipt) {
    this._cmsData = v;
    this.updatePrintStyle();
  }
  _cmsData = new cmsRecipt();
  get cmsData() {
    return this._cmsData;
  }
  private hspidCache: Hspid[] = null;
  constructor(private histApi: HistApi,
    private regApi: RegisterApi,
    private cmsReportApi: CmsReportApi,
    private clinicData: ClinicDataService,
    private cdr: ChangeDetectorRef,
    private sessionService: SessionService,
    private hcr: HcrService,
    private hspidApi: HspidApi,
    private chineseReportApi : ChiReportApi
  ) { }

  private async getHspids(): Promise<Hspid[]> {
    if (!this.hspidCache) {
      var data = await this.hspidApi.GetAll();
      this.hspidCache = Hspid.mapLevel(data).filter(x => x.Htype == 4);
    }
    return this.hspidCache;
  }

  async ngOnInit() {
    //this.setRegId(10267)

  }
  async ngAfterViewInit() {
    await this.updatePrintStyle()
  }

  private reportCache: { [key: string]: CmsReport | CmsPrintReport } = {};

  clearReportCache() {
    this.reportCache = {};
    this.regDataCache = {};
  }

  async getReportByCode(code: string): Promise<CmsReport | CmsPrintReport> {
    if (this.reportCache[code]) {
      return this.reportCache[code];
    }

    let report = await this.cmsReportApi.GetPrintByCode(code);
    this.reportCache[code] = report; // 存進快取
    return report;
  }

  private async getReport(code: string) {
    try {
      this.report = await this.getReportByCode(code);

      if (!this.report) {
        throw '找不到報表'
      }

      if (this.report.Type == 0) {
        this.cmsData = JSON.parse(this.report.Template);
        //報表替代規則 不遞迴替代
        if (this.cmsData.replaceRule?.length > 0 && this.data) {
          var replaceCode = this.data.checkReplace(this.cmsData.replaceRule)
          if (replaceCode) {
            var replaceReport = await this.getReportByCode(replaceCode);
            if (!replaceReport) {
              throw '找不到報表'
            }
            this.report = replaceReport
            this.cmsData = JSON.parse(this.report.Template);
          }
        }
        if (this.cmsData.hrxRule?.length > 0 && this.data) {
          this.data.applyHrxRule(this.cmsData.hrxRule)
        }
      } else {
        // 框架的時候重置 避免serRegId時調用到前一份的設定
        this.cmsData = new cmsRecipt();
      }
      await this.updatePrintStyle();
    } catch (e) {
      throw e;
    }
  }
  async updatePrintStyle(): Promise<void> {
    await new Promise<void>((rs, rj) => {
      setTimeout(() => {
        if (this.reportContainer) {
          var styleNode = this.reportContainer.nativeElement.getElementsByTagName('style').item(0)
          if (styleNode) {
            this.reportContainer.nativeElement.removeChild(styleNode)
          }

          var ss = this.cmsData.width + ' ' + this.cmsData.height;
          var st = document.createElement('style');
          var node = document.createTextNode(
            '@page { size: ' + ss + '; margin: ' + cmsMarginCss(this.cmsData.printMargin) + '; }\n' +
            '@media print {body {margin: 0; padding: 0; color: #000; background-color: #fff;} div { margin:0;padding:0;}}'
          );

          st.appendChild(node);
          st.id = 'st';
          this.reportContainer.nativeElement.appendChild(st);
          this.cdr.markForCheck();
        }
        rs();
      }, 0);
    })

  }
  async setRegIdForPreview(regId: number, chineseReceiptInfo?: ChineseReceiptInfo) {
    const histAndIc = await this.histApi.getReceiptInfo(regId);
    if (!histAndIc?.WholeHist?.Hist) return;
    const p1 = await this.clinicData.getParam('PRN001');
    const opt1 = await this.histApi.getEditOptions();
    const opt2 = await this.regApi.GetEditOptions();
    histAndIc.WholeHist.Hist.HRxs = histAndIc.WholeHist.Hist.HRxs.filter(x => x.SPRule != 5 && x.SPRule != 4);
    const param = new CmsReportAdditionalParamter();
    param.chineseReceiptInfo = chineseReceiptInfo ?? null;
    this.data = new ReceiptData(histAndIc, p1, opt1, opt2, param);
    this.data.Hspids = await this.getHspids();

    const replaceRules = this.cmsData?.replaceRule ?? [];
    if (replaceRules.length > 0) {
      const replaceCode = this.data.checkReplace(replaceRules);
      if (replaceCode) {
        const replaceReport = await this.getReportByCode(replaceCode);
        if (replaceReport?.Template) {
          this.cmsData = JSON.parse(replaceReport.Template);
        }
      }
    }
  }

  async setRegIdForTest(regId: number, drugbagInfo?: DrugBagInfo) {
    //this.editOptions = await this.regApi.GetEditOptions();
    var histAndIc = await this.histApi.getReceiptInfo(regId);
    var p1 = await this.clinicData.getParam('PRN001');
    var opt1 = await this.histApi.getEditOptions();
    var opt2 = await this.regApi.GetEditOptions();

    if (!histAndIc?.WholeHist?.Hist) return;
    histAndIc.WholeHist.Hist.HRxs = histAndIc.WholeHist.Hist.HRxs.filter(x => x.SPRule != 5 && x.SPRule != 4);

    if (!drugbagInfo) {
      drugbagInfo = await this.histApi.getCMSDrugBag(regId, histAndIc.Rx.map(x => x.Id));
    }


    let param: CmsReportAdditionalParamter = new CmsReportAdditionalParamter();
    const isChinese = UserCache.getLoginUser().Clinic.TypeIsChinese;
    if (isChinese) {
      const receiptInfo = await this.chineseReportApi.getChineseReceiptInfo(regId);

    const groupedByRx = receiptInfo.Hrxes.reduce<Record<string, ChineseHrx[]>>((acc, item) => {
      const key = item.RxClass;
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {});

      //只Preview第一頁
        const chineseReceiptInfo = new ChineseReceiptInfo();
        const firstKey = Object.keys(groupedByRx)[0];
        const firstGroup = groupedByRx[firstKey];
        chineseReceiptInfo.chineseRxList = firstGroup;
        param.chineseReceiptInfo = chineseReceiptInfo;
      }


    param.drugBagInfo = drugbagInfo;
    this.data = new ReceiptData(histAndIc, p1, opt1, opt2, param);
    this.data.Hspids = await this.getHspids();

    if (this.cmsData.hrxRule?.length > 0) {
      this.data.applyHrxRule(this.cmsData.hrxRule)
    }
  }

  private regDataCache: { [regId: number]: RegDataCache } = {};
  async getRegData(regId: number): Promise<RegDataCache> {
    if (this.regDataCache[regId]) {
      return this.regDataCache[regId];
    }
    const histAndIc = await this.histApi.getReceiptInfo(regId);
    const p1 = await this.clinicData.getParam('PRN001');
    const opt1 = await this.histApi.getEditOptions();
    const opt2 = await this.regApi.GetEditOptions();
    const useOutVisit = this.sessionService.getData('useOutVisit');
    const useOutVisitJail = this.sessionService.getData('useOutVisitJail');
    const additionPrintSetting = this.sessionService.getData('additionPrintSetting');

    const result = new RegDataCache({
      histAndIc,
      p1,
      opt1,
      opt2,
      useOutVisit,
      useOutVisitJail,
      additionPrintSetting
    });

    this.regDataCache[regId] = result;
    return result;
  }
  public async fetch(regId: number, reportCode: string, param?: CmsReportAdditionalParamter) {
    await this.setRegId(regId, param);
    if (reportCode) {
      await this.getReport(reportCode);
      await this.applyRules()
    }
  }
  private async applyRules() {
    console.log('setRegId >>>>>');
    if (this.cmsData.hrxRule?.length > 0) {
      console.log('call applyHrxRule >>>>>');
      this.data.applyHrxRule(this.cmsData.hrxRule);
    }
  }
  private async setRegId(regId: number, param?: CmsReportAdditionalParamter) {

    var regDataCache = await this.getRegData(regId);
    var histAndIc = regDataCache.histAndIc;
    var p1 = regDataCache.p1;
    var p2 = await this.clinicData.getParam('PRN002');
    var opt1 = regDataCache.opt1;
    var opt2 = regDataCache.opt2;
    var useOutVisit = regDataCache.useOutVisit;
    var useOutVisitJail = regDataCache.useOutVisitJail;
    var additionPrintSetting = regDataCache.additionPrintSetting;

    if (useOutVisit || useOutVisitJail) {   // 巡診並另外設定列印參數
      if (additionPrintSetting) {
        var paramArr: ValueTextPair[] = [];
        var oriParam = additionPrintSetting.replace(/\ /g, '').replace(/\{/g, '').replace(/\}/g, '').replace(/\"/g, '');
        const strs = oriParam.split(',');
        strs.forEach(str => {
          const data = new ValueTextPair();
          if (str.indexOf(':') > 0) {
            data.text = str.split(':')[0];
            data.value = str.split(':')[1];
          } else {
            data.text = str;
            data.value = str;
          }
          paramArr.push(data);
        });
        p1.DoubleSidedPrintType = Number(paramArr.find(x => x.text == 'DoubleSidedPrintType').value);
        p1.ReceiptType = Number(paramArr.find(x => x.text == 'ReceiptType').value);
      }
    }

    if (p2.DontPrintOutSPRule) {
      histAndIc.WholeHist.Hist.HRxs = histAndIc.WholeHist.Hist.HRxs.filter(x => p2.DontPrintOutSPRule.indexOf(x.SPRule) < 0);
    } else {
      histAndIc.WholeHist.Hist.HRxs = histAndIc.WholeHist.Hist.HRxs.filter(x => x.SPRule != 5 && x.SPRule != 4);
    }

    for (let hrx of histAndIc.WholeHist.Hist.HRxs) {
      //  hrx.Remark = hrx.Remark.replace('[自費]', '').replace('[贈送]', '');
      if (hrx.SPRule == OrderSpecialRuleEnum.A2_SelfPayment && !hrx.Price) {
        // 自費項目 沒自費價時 採用健保價數字
        hrx.Price = hrx.IPrice;
      }
    }

    this.data = new ReceiptData(histAndIc, p1, opt1, opt2, param);
    this.data.Hspids = await this.getHspids();
  }
  getHRx() {
    if (!this.data) {
      return [];
    }
    var hrx = this.data.getHrx();
    if (this.hrxPerPage !== null && this.hrxPerPage > 0) {
      const start = this.hrxPage * this.hrxPerPage;
      return hrx.slice(start, start + this.hrxPerPage);
    }
    return hrx;
  }
  getData(col: cmsReceiptCol, arg: { tp: 'hrx', ind: number }) {
    if (!this.data) {
      return '';
    }
    var val;
    if (arg?.tp == 'hrx') {
      val = this.data.getHrxData(arg.ind, col.dataField);
    } else {
      val = this.data.getData(col.dataSource, col.dataField);
    }
    if (col.mapping && col.mapping.Vars.length > 0 && col.mapping.Condi.length > 0) {
      var calcArg = {}
      col.mapping.Vars.forEach(v => {
        // 設定變數 取得值
        if (arg?.tp == 'hrx') {
          val = this.data.getHrxData(arg.ind, col.dataField);
          calcArg[v.n] = this.data.getHrxData(arg.ind, v.f);
        } else {
          calcArg[v.n] = this.data.getData(v.s, v.f);
        }
      })
      val = CmsColDataCalc.TestCond(col.mapping.Condi, calcArg, true)
    }
    var valStart = col?.style?.valStart ? col.style.valStart : 'left';
    var valLength = col?.style?.valLength ?? 0;
    val = this.styleforval(val, valStart, valLength);
    return val;
  }
  mergeStyle(a: cmsReciptStyle, b: cmsReciptStyle) {
    var r = Object.assign({}, a, b);
    //console.log(i,r)
    return r;
  }
  sizeStyle() {
    return {
      width: this.cmsData.width,
      height: this.cmsData.height,
      //width:this.cmsData.width.indexOf('in')>0?('calc('+this.cmsData.width+' / 0.96)'):this.cmsData.width,
      //height:this.cmsData.height.indexOf('in')>0?('calc('+this.cmsData.height+' / 0.96)'):this.cmsData.height,
    }
  }
  innerSizeStyle() {
    if (this.isLayout) {
      return {
        width: this.cmsData.isHelf ? '50%' : '100%',
        // overflow:'hidden'
        // overflow:'hidden'
      }
    }

    return {
      width: this.cmsData.isHelf ? '50%' : '100%',
      height: '100%',
      // overflow:'hidden'
      // overflow:'hidden'
    }
  }
  rowStyle(row: cmsReceiptRow, st: cmsReciptStyle) {
    return {
      flexWrap: row.wrap ? 'wrap' : 'nowrap',
      columnGap: (row.spacing || 0) * (st?.fontSize || this.defaultFontSize) / 2 + 'px'
    }
  }
  style(st: cmsReciptStyle, value: string) {
    var s = {
      marginLeft: (st?.padLeft || 0) * (st?.fontSize || this.defaultFontSize) / 2 + 'px',
      fontSize: (st.fontSize || this.defaultFontSize) + 'px',
      fontFamily: st.fontFamily || this.defaultFontFamily,
      textAlign: st.textAlign || 'left',
      display: st.hiddenIfEmpty && !value ? 'none' : 'block',
      textOverflow: st.textOverflow ?? 'clip'
    }
    if (st.width) {
      s = Object.assign(s, {
        width: (st?.width || 0) * (st?.fontSize || this.defaultFontSize) / 2 + 'px',
        minWidth: (st?.width || 0) * (st?.fontSize || this.defaultFontSize) / 2 + 'px',
        maxWidth: (st?.width || 0) * (st?.fontSize || this.defaultFontSize) / 2 + 'px'
      });
    }
    if (st.multiLine) {
      s = Object.assign(s, {
        whiteSpace: 'pre-line'
      })
    }
    return s;

  }
  styleforval(
    str: any,                           // 改成 any
    valStart: 'left' | 'right' = 'left',
    valLength?: number
  ): string {
    // 先把 null / undefined 轉成空字串，其他型別轉成字串
    str = str != null ? String(str) : '';

    // 如果沒有 valLength，就回傳整個字串
    if (!valLength || valLength <= 0) return str;

    // 從左或從右截取
    return valStart === 'left' ? str.slice(0, valLength) : str.slice(-valLength);
  }
  page: number = 1; //頁數，如果有分頁的話把這個值改掉
  @ViewChild('reportContainer')
  reportContainer: ElementRef<HTMLDivElement>;

  async getHtml(type: number) {
    //是布局的話
    if (this.report.Type == 1) {

      var layout: CmsLayout = JSON.parse(this.report.Template);

      var d = document.createElement('div');
      d.style.display = 'flex';
      d.style.flexWrap = 'wrap';
      d.style.width = layout.width;
      d.style.height = layout.height;
      d.style.alignContent = 'flex-start';

      var defaultWidthRatio = 100 / layout.cols;

      this.isLayout = true;
      for (let code of layout.contents) {

        var content = code as LayoutContent;

        let ratio = defaultWidthRatio;

        if (content.ratio !== undefined) {
          ratio = content.ratio;
        }
        ;
        var codeValue = content?.value;
        if (codeValue === undefined) {
          codeValue = code as string;
        }


        // 容器
        var d2 = document.createElement('div');
        d2.style.width = 'calc( ' + ratio + '%)';
        // 取內容

        if (codeValue) {
          if (content.firstPageOnly && this.page !== 1) {

          }
          else {
            var r = await this.getReportByCode(codeValue);
            if (r && r.Template) {
              this.cmsData = JSON.parse(r.Template);
              if (this.cmsData.hrxRule?.length > 0) {
                // 資料套用醫令規則
                this.data.applyHrxRule(this.cmsData.hrxRule)
              }
              // 等待繪製 並將Html取出
              await new Promise<void>((rs, rj) => {
                setTimeout(() => {
                  // 置入容器
                  var html = this.reportContainer.nativeElement.innerHTML;
                  d2.innerHTML = html;
                  // 版面尺寸與邊界由布局單一宣告；各區塊自帶的 @page 一併搬入會與之衝突，
                  // 移除後被布局使用的報表其頁寬頁高不再影響列印結果。
                  var nested = d2.querySelector('style#st');
                  if (nested) {
                    nested.parentNode.removeChild(nested);
                  }
                  rs();
                }, 0);
              })
            }
          }
        }
        // 加入配置
        d.appendChild(d2);
      }

      var ss = layout.width + ' ' + layout.height;
      var ps = await this.hcr.GetPaperSize(type);
      if (ps && !layout.useCustomSize) {
        ss = `${ps.Width / 100}in ${ps.Height / 100}in`; //page-orientation: rotate-left;
      }

      var st = document.createElement('style');
      var node = document.createTextNode(
        '@page { size: ' + ss + '; margin: ' + cmsMarginCss(layout.printMargin) + '; }\n' +
        '@media print {body {margin: 0; padding: 0; color: #000; background-color: #fff;} div { margin:0;padding:0;}}'
      );

      st.appendChild(node);
      st.id = 'st';
      d.appendChild(st);
      var layoutContainer = document.createElement('div');
      layoutContainer.appendChild(d);
      layoutContainer.style.display = 'flex';
      layoutContainer.style.justifyContent = 'center';
      // 取出html
      var h = layoutContainer.outerHTML;
      this.isLayout = false;
      return h;
    } else {
      this.isLayout = false;
      var html = this.reportContainer.nativeElement.innerHTML;

      return html;
    }

  }


}
